import React from 'react';
import backdropOverlayStyles from './backdropOverlay.module.pcss';

interface BackdropOverlay {
  handleClose: () => void;
  canDisplayDropdown: boolean;
}

function BackdropOverlay({ canDisplayDropdown, handleClose }: BackdropOverlay): React.ReactElement {
  return canDisplayDropdown ? (
    <div onClick={handleClose} role="presentation" className={backdropOverlayStyles.backdropOverlay} />
  ) : (
    <></>
  );
}

export default BackdropOverlay;
